<template>
  <div>
    <div class="content">
      <div class="main">
        <div class="page-title">
          <el-image
            class="left-icon"
            src="https://pub.cloud.xbjy123.com/UserHeads/30/20230112/690226236609265664.jpg"
          />
          <div class="text">全部课程</div>
        </div>
        <div class="categorys">
          <div class="row">
            <div class="label">一级分类</div>
            <div class="cells">
              <div
                v-for="(p, pk) in category"
                :key="pk"
                class="cell"
                :class="{ active: cateIndex[0] == pk }"
                @click="parentClick(pk)"
              >
                {{ p.name }}
              </div>
            </div>
          </div>
          <div class="row">
            <div class="label">二级分类</div>
            <div class="cells">
              <div
                v-for="(c, ck) in childList"
                :key="ck"
                class="cell"
                :class="{ active: cateIndex[1] == ck }"
                @click="childClick(ck)"
              >
                {{ c.name }}
              </div>
            </div>
          </div>
        </div>
        <div class="courses">
          <div class="pre">
            <span>共计 {{ total }} 套课程</span>
          </div>
          <div class="list-out">
            <div class="list">
              <div
                v-for="(i, k) in list"
                :key="k"
                class="item"
                @click="goCourseDetails(i.id)"
              >
                <el-image class="cover" fit="cover" :src="i.cover_pc" />
                <div class="info">
                  <div style="min-height: 51px">
                    <div class="title line-1">{{ i.name }}</div>
                    <div class="desc line-1">
                      {{ i.description }}
                    </div>
                  </div>
                  <div class="price">
                    <div class="p">
                      ¥<span>{{ i.sell_price * 1 }}</span>
                    </div>
                    <div class="t">官方原价</div>
                  </div>
                  <div class="bottom">
                    <div v-if="i.teachers.length > 0" class="teacher">
                      <el-image class="head" :src="i.teachers[0].headpic" />
                      <div class="name">{{ i.teachers[0].name }}</div>
                    </div>
                    <div v-else class="teacher"></div>
                    <div class="learn">{{ i.learn_num }}人学习</div>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="loadState == 1" class="laodmore s1">
              <i class="el-icon-loading"></i> 加载中
            </div>
            <div v-else-if="loadState == 2" class="laodmore">没有更多了</div>
            <div v-else class="laodmore s0" @click="loadNextPage">加载更多</div>
          </div>
        </div>
      </div>
    </div>
    <right-fixed-box />
  </div>
</template>

<script>
import rightFixedBox from '@/components/common/right-fixed-box.vue'
import { getPageData, getCateCourses } from '@/network/request'
export default {
  name: 'CourseCenter',
  components: { rightFixedBox },
  data() {
    return {
      cate_id: 0,
      category: [],
      cateIndex: [0, 0],
      pager: {
        page: 1,
        limit: 12,
      },
      loadState: 0, // 0 常规 1 加载中 2 没有更多了
      list: [],
      total: 0,
    }
  },
  computed: {
    childList() {
      let pk = this.cateIndex[0] || 0
      return this.category[pk] ? this.category[pk].children || [] : []
    },
  },
  mounted() {
    this.cate_id = this.$route.params.cate_id || 0
    this.loadPageData()
  },
  methods: {
    loadPageData() {
      getPageData({ alias: 'COURSE_CENTER' }).then(({ data }) => {
        let category = data.result.params.category || []
        category.unshift({ id: 0, name: '全部', children: [] })
        category.forEach((item, index) => {
          item.children.unshift({ id: 0, name: '全部' })
          if (item.id == this.cate_id) {
            this.$set(this, 'cateIndex', [index, 0])
          }
        })
        this.category = category
        this.fetchCourseList(true)
      })
    },
    parentClick(pk) {
      this.$set(this, 'cateIndex', [pk, 0])
      this.cate_id = this.category[pk].id
      this.fetchCourseList(true)
    },
    childClick(ck) {
      this.$set(this.cateIndex, 1, ck)
      let pk = this.cateIndex[0]
      let list = this.category[pk].children
      this.cate_id = list[ck].id ? list[ck].id : this.category[pk].id
      this.fetchCourseList(true)
    },
    loadNextPage() {
      if (this.loadState == 0) {
        this.pager.page += 1
        this.fetchCourseList()
      }
    },
    // 加载列表
    fetchCourseList(reload = false) {
      if (reload) {
        this.pager.page = 1
        this.list = []
      }
      this.loadState = 1
      getCateCourses({
        cate: this.cate_id,
        page: this.pager.page,
        limit: this.pager.limit,
      })
        .then(({ data }) => {
          let list = data.result.data
          list.forEach((i) => {
            this.list.push(i)
          })
          let { total, page, page_last } = data.result
          this.total = total
          console.info(data.result, this.list)
          // if (!this.cateInfo) {
          //   this.cateInfo = data.result.cate_info
          //   this.courseList = data.result.data
          // }
          this.loadState = page >= page_last ? 2 : 0
        })
        .catch(() => {
          this.loadState = 0
        })
    },
    goCourseDetails(courseId) {
      this.$router.push({
        name: 'CourseDetails',
        params: {
          course_id: courseId,
        },
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.main {
  width: 1240px;
  padding: 0 20px;
  margin: 0 auto;
}

.content {
  min-width: 1240px;
  padding-top: 32px;

  .page-title {
    display: flex;
    align-items: center;
    margin-bottom: 30px;
    .left-icon {
      width: 32px;
      height: 32px;
      margin-right: 10px;
    }
    .text {
      font-size: 28px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #000000;
      line-height: 40px;
    }
  }

  .categorys {
    min-height: 100px;
    .row {
      display: flex;
      align-items: center;
      margin-bottom: 20px;
      min-height: 40px;
      &:last-child {
        margin-bottom: 0;
      }
      .label {
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #a9a9a9;
        line-height: 22px;
        margin-right: 30px;
        min-width: 66px;
      }
      .cells {
        display: flex;
        align-items: center;
        .cell {
          background: #f5f5f5;
          border: 1px solid #f5f5f5;
          border-radius: 6px;
          min-width: 56px;
          height: 40px;
          text-align: center;
          line-height: 38px;
          padding: 0 12px;
          margin-left: 20px;
          &:first-child {
            margin-left: 0;
          }
          font-size: 16px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #717171;

          cursor: pointer;
          &:hover {
            color: #1296ff;
          }
          &.active {
            color: #1296ff;
            background: rgba(18, 150, 255, 0.05);
            border-color: rgba(18, 150, 255, 0.1);
          }
        }
      }
    }
  }
  .courses {
    padding-bottom: 56px;
    .pre {
      height: 30px;
      line-height: 30px;
      margin-bottom: 10px;
      text-align: right;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #828282;
    }
    .list-out {
      min-height: 474px;
      margin-left: -28px;
      margin-top: -28px;
    }
    .laodmore {
      margin: 30px auto 0 auto;
      width: 100px;
      line-height: 40px;
      text-align: center;
      color: #828282;
      &.s0 {
        cursor: pointer;
        color: #209cff;
      }
    }
    .list {
      min-height: 60px;
      display: flex;
      flex-wrap: wrap;
      .item {
        width: 279px;
        height: 335px;
        margin-left: 28px;
        margin-top: 28px;
        background: #fff;
        box-shadow: 0px 10px 20px 0px #f5f6f7;
        border-radius: 10px;
        overflow: hidden;

        cursor: pointer;
        transition: transform 0.13s ease;
        &:hover {
          transform: scale(1.03);
        }

        .cover {
          width: 100%;
          height: 159px;
        }
        .info {
          padding: 14px 16px 0 16px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          .title {
            font-size: 18px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #000000;
            line-height: 25px;
            margin-bottom: 6px;
          }
          .desc {
            font-size: 14px;
            color: #00000080;
            line-height: 20px;
          }
          .price {
            display: flex;
            align-items: baseline;
            font-family: AlibabaPuHuiTi-Bold, AlibabaPuHuiTi;
            margin: 12px 0;
            .p {
              font-size: 16px;
              font-weight: bold;
              color: #ff440f;
              line-height: 22px;
              & > span {
                font-size: 24px;
                line-height: 33px;
              }
            }
            .t {
              font-size: 12px;
              font-weight: 400;
              color: #bababa;
              margin-left: 4px;
              position: relative;
              top: -2px;
              text-decoration: underline;
            }
          }
          .bottom {
            display: flex;
            justify-content: space-between;
            align-items: center;
            border-top: 1px solid #ebebeb;
            padding: 12px 0;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #828282;
            .teacher {
              display: flex;
              align-items: center;
              height: 27px;
              .head {
                width: 27px;
                height: 27px;
                border-radius: 50%;
                margin-right: 8px;
              }
              .name {
                font-size: 14px;
              }
            }
            .learn {
              font-size: 12px;
            }
          }
        }
      }
    }
  }
}
</style>
